// @ts-nocheck
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaChevronDown } from 'react-icons/fa';

import AlbanianFlag from '../assets/icons/albania.svg';
import EnglishFlag from '../assets/icons/EnglishFlag.png';
import ItalianFlag from '../assets/icons/italianFlag.png';
import GermanFlag from '../assets/icons/GermanFlag.png';
import SpainFlag from '../assets/icons/SpainFlag.png';
import PolishFlag from '../assets/icons/polish.png';
import UkraineFlag from '../assets/icons/Flag_of_Ukraine_Flat_Round-64x64.png';

const languages = [
    { code: 'en', name: 'English', flag: EnglishFlag },
    { code: 'sq', name: 'Shqip', flag: AlbanianFlag },
    { code: 'it', name: 'Italiano', flag: ItalianFlag },
    { code: 'de', name: 'Deutsch', flag: GermanFlag },
    { code: 'es', name: 'Español', flag: SpainFlag },
    { code: 'pl', name: 'Polski', flag: PolishFlag },
    { code: 'ukr', name: 'Українська', flag: UkraineFlag },
];

const LanguageSelector = () => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const currentLanguageCode = i18n.language || 'en';
    const selectedLanguage = languages.find(lang => lang.code === currentLanguageCode) || languages[0];

    const handleLanguageChange = (code) => {
        i18n.changeLanguage(code);
        setIsOpen(false);
    };

    return (
        <div className="relative z-50" ref={dropdownRef}>
            {/* Trigger Button */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-2 px-3 py-2 bg-indigo-50 hover:bg-indigo-100 text-indigo-700 rounded-full transition-all duration-200 border border-indigo-100 focus:outline-none focus:ring-2 focus:ring-indigo-200"
            >
                <div className="w-5 h-5 rounded-full overflow-hidden shadow-sm border border-black/10">
                    <img
                        src={selectedLanguage.flag}
                        alt={selectedLanguage.name}
                        className="w-full h-full object-cover"
                    />
                </div>
                <span className="text-sm font-semibold hidden sm:inline-block">{selectedLanguage.name}</span>
                <FaChevronDown className={`text-xs transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
            </button>

            {/* Dropdown Menu */}
            {isOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-xl border border-slate-100 overflow-hidden animate-fade-in-down origin-top-right">
                    <div className="py-1 max-h-[60vh] overflow-y-auto custom-scrollbar">
                        {languages.map((language) => (
                            <button
                                key={language.code}
                                onClick={() => handleLanguageChange(language.code)}
                                className={`w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-slate-50 transition-colors ${currentLanguageCode === language.code ? 'bg-indigo-50 text-indigo-700 font-medium' : 'text-slate-700'
                                    }`}
                            >
                                <div className="w-5 h-5 rounded-full overflow-hidden shadow-sm border border-slate-200 flex-shrink-0">
                                    <img
                                        src={language.flag}
                                        alt={language.name}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <span className="text-sm">{language.name}</span>
                                {currentLanguageCode === language.code && (
                                    <div className="ml-auto w-1.5 h-1.5 rounded-full bg-indigo-500"></div>
                                )}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default LanguageSelector;
